import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AmlHistoryRequest, GetAmlHistoryItemRequest } from '@/api';
import { AmlHistoryData, AmlHistoryItemData } from '../models';

export interface AmlHistorySliceState {
  data: AmlHistoryData;
  loading: boolean;
  error: string | null;
}

const initialState: AmlHistorySliceState = {
  data: null,
  loading: false,
  error: null,
};

const amlHistorySlice = createSlice({
  name: 'amlHistory',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<AmlHistoryData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchAmlHistory: (state, action: PayloadAction<AmlHistoryRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    addData: (state, action: PayloadAction<AmlHistoryData>) => {
      if (action.payload === null) {
        return {
          ...state,
          data: null,
        };
      }

      const currentItems = JSON.parse(JSON.stringify(state.data?.items || []));
      const { items, ...newData } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          ...newData,
          items: [...currentItems, ...items],
        },
      };
    },
    refreshDataItem: (state, action: PayloadAction<AmlHistoryItemData>) => {
      if (!action.payload) {
        return;
      }

      if (!state.data) {
        state.data = {
          result: true,
          pageLimit: 0,
          totalCount: 0,
          balance: 0,
          amlFlow: action.payload.flow,
          discount: 0,
          discountDueTime: 0,
          promoFlow: false,
          usePromoFlow: false,
          devModeUsed: false,
          items: [],
        };
      }

      const currentItems: AmlHistoryItemData[] = JSON.parse(
        JSON.stringify(state.data.items || []),
      );
      const newItems = [...currentItems];
      const itemIndex = currentItems.findIndex(
        (item) => item.uuid === action.payload.uuid,
      );

      if (itemIndex !== -1) {
        newItems.splice(itemIndex, 1, action.payload);
      } else {
        newItems.push(action.payload);
      }

      state.data.items = newItems;
    },
    fetchHistoryItem: (
      state,
      action: PayloadAction<GetAmlHistoryItemRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { amlHistorySlice };
